"use client";

import _extends from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["className", "variant", "size"];
var __jsx = React.createElement;
import * as React from "react";
import classNames from "classnames";
export var Button = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? "default" : _ref$variant,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "default" : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var variantClasses = {
    "default": "bg-primary text-primary-foreground hover:bg-primary/90",
    destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
    outline: "border border-input bg-background hover:bg-accent hover:text-accent-foreground",
    ghost: "hover:bg-accent hover:text-accent-foreground",
    link: "text-primary underline-offset-4 hover:underline"
  };
  var sizeClasses = {
    "default": "px-4 py-2",
    sm: "px-4 py-3 rounded-md px-3",
    lg: "px-5 py-3 rounded-md px-8",
    icon: ""
  };
  return /*#__PURE__*/React.createElement("button", _extends({
    className: classNames("inline-flex items-center justify-center rounded-md text-base font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50", variantClasses[variant], sizeClasses[size], className),
    ref: ref
  }, props));
});
Button.displayName = "Button";